import styled from '@emotion/styled'

export const CommitteeApproveContainer = styled.div({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  margin: '10px',
})